import { QtmButton, QtmIcon } from '@qtm/react';
import { useNavigate } from 'react-router-dom';
import './home.css';

const Home = () => {
  const navigate = useNavigate();

  const navigateTo = (path: string) => () => {
    navigate(path);
  };

  return (
    <div className="home">
      <div className="page-title">Welcome in our ALL-IN-ONE Dashboard!</div>
      <div className="page-subtitle">
        This site will allow you to measure the different indicators of ALL-IN-ONE users. You will
        be able to visually see the global dashboard or more precisely per user:
      </div>

      <div className="card-wrapper">
        <div className="card">
          <div className="card-icon">
            <QtmIcon icon="pie_chart" size="xxlarge" />
          </div>
          <div>
            <QtmButton variant="outline" onClick={navigateTo('/dashboard')}>
              See Dashboard
            </QtmButton>
          </div>
        </div>
        <div className="card">
          <div className="card-icon">
            <QtmIcon icon="group" size="xxlarge" />
          </div>
          <div>
            <QtmButton variant="outline" onClick={navigateTo('/users')}>
              See Users
            </QtmButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
